//
// # GenAlphaModel Namespace
//

export * from "./model";
export * as model from "./model";
export * as schdata from "./schematic"; // FIXME: deprecate this
export * from "./schematic";
export * as netlist from "./netlist";
export * from "./netlist";
export * as srv from "./srv";

// Circuit-connectivity extraction (consumed by the infer-sch-conns dev CLI).
export { extractCircuit, UnconnectedInstancePort } from "./circuit/extractor";
